import {$auth} from "@/plugins/auth"
import type {NavigationGuardNext, RouteLocationNormalized, RouteLocationNormalizedLoaded} from "vue-router"
import {ROUTES} from "@/router/paths"
import routeTo from "@/plugins/route"
import {UserTypes} from "@/enums/UserTypes"

export default class SignupComplete implements App.Middleware.Instance {
  async handle(
    to: RouteLocationNormalized,
    from: RouteLocationNormalizedLoaded,
    next: App.Middleware.Caller,
    cancel: NavigationGuardNext
  ): Promise<void> {
    if ($auth.user && !$auth.user.is_onboarding_complete) {
      return cancel(routeTo($auth.user.user_type === UserTypes.BENEFICIARY ? ROUTES.BENEFICIARY_SIGNUP : ROUTES.REGISTER))
    }

    await next(to, from, cancel)
  }
}
